/**
 * Fallback icons for account navigation items that do not define `icon`.
 * Shared by My Account card nav and the Presidio All drawer.
 */
export const ACCOUNT_NAVIGATION_ICONS: Record<string, string> = {
  'my-account': 'bi-speedometer2',
  orders: 'bi-list-ul',
  'recurring-orders': 'bi-arrow-repeat',
  requisitions: 'bi-clipboard-check',
  approvals: 'bi-check2-square',
  quotes: 'bi-file-earmark-text',
  'order-templates': 'bi-files',
  invoices: 'bi-receipt',
  wishlists: 'bi-heart',
  favorites: 'bi-heart',
  warehouse: 'bi-boxes',
  addresses: 'bi-geo-alt',
  users: 'bi-people',
  'cost-centers': 'bi-diagram-3',
  punchout: 'bi-box-arrow-up-right',
  'org-settings': 'bi-sliders',
  profile: 'bi-person-gear',
  payment: 'bi-credit-card',
  notifications: 'bi-bell',
  logout: 'bi-box-arrow-right',
  // CUSTOMIZATION: Presidio portal domains
  contracts: 'bi-file-earmark-medical',
  'sales-admin': 'bi-sliders',
  devices: 'bi-cpu',
  reports: 'bi-bar-chart-fill',
  workitems: 'bi-clipboard2-check',
};

export function accountNavigationIcon(id: string, itemIcon?: string): string {
  return itemIcon ?? ACCOUNT_NAVIGATION_ICONS[id] ?? 'bi-grid-1x2';
}
